import React from 'react';
export const BlockLogo = ({ image, align, width, height }) => (React.createElement("div", { style: { width: '100%', textAlign: align } },
    React.createElement("img", { alt: 'image', width: width || '130px', src: `${process.env.REACT_APP_SERVER}${image}` })));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockLogo.tsx
// module id = 506
// module chunks = 0